// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoBlade-module--videoContainer--1bfC-","embed":"VideoBlade-module--embed--158SR","root":"VideoBlade-module--root--ots2X"};